import styled from 'styled-components'

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  ul {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      margin-right: 0.5rem;
      border: solid 1px;
      cursor: pointer;
      user-select: none;

      a {
        display: block;
        width: 100%;
        height: 100%;
        padding: 0.5rem;
      }

      &.active {
        background-color: ${({ theme }) => theme.bg7};
        color: #fff;
        border-color: ${({ theme }) => theme.bg7};
      }

      &.disabled {
        background-color: transparent !important;
        opacity: 0.5;
        user-select: none;
        cursor: not-allowed;
      }

      :hover {
        background-color: ${({ theme }) => theme.bg3};
      }

      :last-child {
        margin-right: 0;
      }
    }
  }
`
